module.exports = __webpack_public_path__ + "static/media/Item_Weapon_M24_C.a09f5721.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_M24_C.png
// module id = ./src/assets/item/Weapon/Main/Item_Weapon_M24_C.png
// module chunks = 0